/* Built In Imports */

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import ShivaBlockCard from '@msr/components/Card/ShivaBlockCard';
import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';

/* Services */

/**
 * @param {Object} posts
 * @returns
 */
const RelatedContent = ({ posts, lang, page }) => {
  return posts?.length > 0 && (
    <Box
      bgColor="#090D49"
      pt="10px"
      pb="80px"
    >
      <MsrSectionTitle titleObj={{ titleDecoration: 'drums-above', titleText: 'Related Content' }} />
      <Box
        gridGap={{ base: '20px', md: '15px' }}
        gridRowGap={{ base: '20px', md: '40px' }}
        display={{ base: 'grid', md: 'flex' }}
        flexFlow="wrap"
        mx={{ base: '4', md: 'auto' }}
        mt="30px"
        maxW="1140px"
        justifyContent="center"
      >
      
        {posts?.map(post => {
          return (
            <Box maxW="370px" width="100%" bg="#252964">
              <ShivaBlockCard content={post} lang={lang} page={page} />{' '}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default RelatedContent;
